import type { IAnalyticsAdapter, AnalyticsConfig } from '../types';

// Logs all events to the browser console.
// Use in development to verify tracking without sending real data.
export class ConsoleAdapter implements IAnalyticsAdapter {
  private prefix = '[Analytics]';

  init(_config: AnalyticsConfig) {
    console.log(`${this.prefix} Initialized (console mode)`);
  }

  identify(userId: string, traits?: Record<string, unknown>) {
    console.log(`${this.prefix} identify`, { userId, traits });
  }

  track(event: string, properties?: Record<string, unknown>) {
    console.log(`${this.prefix} track "${event}"`, properties ?? {});
  }

  page(pageName: string, properties?: Record<string, unknown>) {
    console.log(`${this.prefix} page "${pageName}"`, properties ?? {});
  }

  reset() {
    console.log(`${this.prefix} reset`);
  }
}
